export class LogRequest {
  message: string;
  clientUrl: string;
}

export class FormErrorLogRequest extends LogRequest {
  formId: string;
  formOverrideId: string;
  formIdQueue: string;
}
